export const html = "<p>Tour and taste at the Ararat or Noy brandy factory.</p>\n";
export const leadHtml = "<p>Tour and taste at the Ararat or Noy brandy factory.</p>\n";
export const bodyHtml = "";
export const metaText = "Tour and taste at the Ararat or Noy brandy factory.";